import { type ReactElement } from 'react';

// Haendler-/Gegenpartei-Name -> Cache-Schluessel. MUSS mit dem Backend
// (normalizeMerchantKey) uebereinstimmen, damit Logos zugeordnet werden.
export function merchantKey(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\bgmbh\b|\bag\b|\bug\b|\bkg\b|\bohg\b|\bgbr\b|\be\.?\s?k\.?\b|\bltd\b|\blimited\b|\binc\b|\bllc\b|\bs\.?\s?a\.?\b|\bse\b|\bco\b|\bplc\b|\bb\.?v\.?\b/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, '-');
}

const BADGE_COLORS = [
  'bg-blue-100 text-blue-700', 'bg-emerald-100 text-emerald-700', 'bg-amber-100 text-amber-700',
  'bg-violet-100 text-violet-700', 'bg-rose-100 text-rose-700', 'bg-cyan-100 text-cyan-700',
  'bg-indigo-100 text-indigo-700', 'bg-teal-100 text-teal-700',
];
function badgeColor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return BADGE_COLORS[h % BADGE_COLORS.length]!;
}
function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
}

/** Kreis-Badge: echtes Logo, sonst Initialen mit stabiler Farbe. */
export function MerchantBadge({ name, logo }: { name: string; logo?: string | null | undefined }): ReactElement {
  if (logo) {
    return (
      <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-white">
        <img src={logo} alt="" className="h-full w-full object-contain" />
      </span>
    );
  }
  return (
    <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold ${badgeColor(name)}`}>
      {initials(name)}
    </span>
  );
}
